export enum ApplicationCrumbType {
    BasicInfo = 'basicInfoCrumb',
    Property = 'propertyCrumb',
    Budget = 'budgetCrumb',
    Specs = 'specsCrumb',
    Review = 'reviewCrumb',
}
